import { render, staticRenderFns } from "./NewEditAlunoPage.vue?vue&type=template&id=f0fb7d8e&scoped=true"
import script from "./NewEditAlunoPage.vue?vue&type=script&lang=js"
export * from "./NewEditAlunoPage.vue?vue&type=script&lang=js"
import style0 from "./NewEditAlunoPage.vue?vue&type=style&index=0&id=f0fb7d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fb7d8e",
  null
  
)

export default component.exports